import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

export function useDeviceSize() {
  const [isMobileDeviceResized, setIsMobileDeviceResized] = useState(false);

  const isTablet = useMediaQuery({
    query: '(min-width: 768px) and (max-width: 992px)',
  });

  const handleMediaQueryChange = (matches: boolean) => {
    setIsMobileDeviceResized(matches);
  };

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' }, undefined, handleMediaQueryChange);

  return { isTablet, isMobile, isMobileDeviceResized };
}
